module.exports = __webpack_public_path__ + "img/ceo.dcdd036e.jpg";